import { render, staticRenderFns } from "./PopupRejectJoinAccount.vue?vue&type=template&id=68c3f314&scoped=true"
import script from "./PopupRejectJoinAccount.vue?vue&type=script&lang=js"
export * from "./PopupRejectJoinAccount.vue?vue&type=script&lang=js"
import style0 from "./PopupRejectJoinAccount.vue?vue&type=style&index=0&id=68c3f314&prod&lang=scss&scoped=true"
import style1 from "./PopupRejectJoinAccount.vue?vue&type=style&index=1&id=68c3f314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c3f314",
  null
  
)

export default component.exports